import axios from 'axios'
import { useStore } from '@/stores/index.js'

function generateNonce(length = 13) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}


export function createAxiosInstance(options = {}) {


  const {
    baseURL = import.meta.env.VITE_APP_API_BASE_URL,
    timeout = 30000,
    getAuth,
    showLoading,
    hideLoading,
    showError,
    handle403,
  } = options;

  const instance = axios.create({
    baseURL,
    timeout,
    headers: { "Content-Type": "application/json" },
  });
  /**
   * 请求拦截
   */
  instance.interceptors.request.use(
    (config) => {

      const store = useStore()
      const { sign, uid } = store.userInfo || {}

      //所有请求都带
      const commonParams = {
        nonce: generateNonce(),
        timestamp: Date.now(),
      }

      // console.error(sign);
      // console.error(uid);

      //只有“需要登录态”的请求才带
      if (!config.noAuth && sign && uid) {
        // commonParams.sign = sign
        // commonParams.userid = uid
      }

      // 开启 loading
      showLoading && showLoading()

      // 获取基础参数（比如 P_PARAMS）
      const baseParams = getAuth ? getAuth() : {}

      // 根据请求类型合并参数
      if (config.method === 'post') {
        config.data = {
          ...baseParams,
          ...commonParams,
          ...(config.data || {}),
        }

      }

      return config
    },
    (error) => {
      hideLoading && hideLoading()
      return Promise.reject(error)
    }
  )

  /**
   * 响应拦截
   */
  //   instance.interceptors.response.use(
  //   (response) => {
  //     hideLoading && hideLoading()

  //     const res = response.data
  //     const url = response.config.url

  //     // 兼容字符串/数字
  //     const state = Number(res.state)

  //     try {
  //       // ========================
  //       // state = -1（强制登出）
  //       // ========================
  //       if (state === -1) {
  //         // const ignoreList = [
  //         //   "/userSign/getSignInfo",
  //         //   "/userSign/signByDay",
  //         //   "/userSign/allSignReward"
  //         // ]

  //         // const isIgnore = ignoreList.includes(url)

  //         console.error("Error-1:", url);

  //         // if (!isIgnore) {
  //         //   // 模拟 Cocos 逻辑
  //         //   localStorage.setItem("AUTOLOGIN", "false")
  //         //   localStorage.setItem("AUTOSHOWLOGIN", "true")

  //         //   // 你项目里的处理方式（自行替换）
  //         //   window.location.reload()

  //         //   return Promise.reject(res)
  //         // } else {
  //         //   console.warn("过滤签到接口:", url)
  //         // }
  //       }

  //       // ========================
  //       // 成功
  //       // ========================
  //       if (state === 200) {
  //         return res.resultData;
  //       }

  //       // ========================
  //       // token 过期（原400）
  //       // ========================
  //       if (state === 400) {
  //         // 这里你可以接入自己的 token 清理逻辑
  //         showError && showError("please login again")
  //         return Promise.reject(res)
  //       }

  //       // ========================
  //       //
  //       // ========================
  //       if (showError) {
  //         showError(res.msg || res.message || `Error: ${url}`)
  //       }

  //       return Promise.reject(res)

  //     } catch (err) {
  //       console.error("解析异常:", err)
  //       return Promise.reject(res)
  //     }
  //   },

  //   (error) => {
  //     hideLoading && hideLoading()

  //     console.error(error.response.request);


  //     if (error.response) {
  //       const status = error.response.status

  //       if (status === 403) {
  //         handle403 && handle403('登录失效或无权限')
  //       } else {
  //         showError && showError(`${error.response.request.responseURL} Error (${status})`)
  //       }
  //     } else {
  //       showError && showError('网络异常，请稍后重试')
  //     }

  //     return Promise.reject(error)
  //   }
  // )


  instance.interceptors.response.use(
    (response) => {
      hideLoading && hideLoading()
      console.log(response.data);

      const res = response.data

      // 👉 这里按你的后端结构调整
      // 假设：{ code: 200, data: xxx, message: '' }

      if (res.state === "200") {
        return res
      } else if (res.state === "403") {
        handle403 && handle403(res.msg || 'Login expired or no permission')
        return Promise.reject(res)
      }
      else if (res.state === "500") {
        handle403 && handle403(res.msg)
        return Promise.reject(res)
      }
      else {
        showError && showError(`${response.request.responseURL} RequestError`)
        return Promise.reject(res)
      }
    },
    (error) => {
      hideLoading && hideLoading()

      // 网络错误 / HTTP 错误
      if (error.response) {
        const status = error.response.status

        if (status === 403) {
          handle403 && handle403('Login expired or no permission')
        } else {
          showError && showError(`RequestError (${status})`)
        }
      } else {
        showError && showError('RequestError Please try again later')
      }

      return Promise.reject(error)
    }
  )

  return instance
}
